import React, { Component } from 'react';
import { Input } from 'antd';
import debounce from "lodash.debounce";
import { axiosInstance } from 'api/apiModule';
class TokenVerifier extends Component {
  constructor(props) {
    super(props);
    this.state = { };
    const debounceInterval = props.timeout || 1000;
    this.makeRequest = this.makeRequest.bind(this);
    this.makeRequest = debounce(this.makeRequest, debounceInterval);
  }
  
  onChange = (value) => {
    console.log("value", value);
    // make http request
    this.makeRequest(value);
    
  };
  makeRequest = async function(value) {
    try {
      const finalUrl = this.props.prepareUrl(value);
      const response = await axiosInstance.instance.get(finalUrl);
      this.props.callback("success", response);
      console.log(response);
    } catch (error) {
      console.error(error);
      this.props.callback("error", error);
    }
  };
  render() {
    return <Input onChange={this.onChange} />;
  }
}

export default TokenVerifier;